<!-- 采购退货 -->
<template>
  <div class='page_content'>
    <processAuditAction ref="processAuditAction"></processAuditAction>
    <subComponents ref="showSelectData"></subComponents>
    <div class="page_content_top">
      <v-button :buttonList="buttonList" @actionSet="actionSet" @getPageInfo="getPageInfo" @openFormDesign="openFormDesign"></v-button>
      <div class="page_content_top_line">
        <v-search v-if="pageShowData.jurHead" :flagList="['woamSalesman']" :searchList="pageShowData.jurHead.jurconfigform" :getRequestData="getRequestData" @searchData="searchData" @openSearch="openSearch">
          <template slot="searchInput" slot-scope="{formOneValue}">
            <!-- 业务员	 -->
            <el-select filterable v-if="formOneValue.entityField == 'woamSalesman'" v-model="getRequestData[formOneValue.entityField]">
              <el-option label="全部" value="">
              </el-option>
              <el-option v-for="(values, keys) in userOneList" :key="keys" :label="values.opmName" :value="values.opmId">
              </el-option>
            </el-select>
          </template>
        </v-search>
      </div>
    </div>
    <div class="page_content_center">
      <el-table v-if="pageShowData.jurTableVo" stripe :data="returnData.list" size="mini" :height="tableHeight" :key="$store.state.tableNum" border style="width: 100%" highlight-current-row @selection-change="handleSelectionChange">
        <el-table-column type="selection" width="40">
        </el-table-column>
        <el-table-column align="center" v-if="tableValye.isShow == 1" v-for="(tableValye, tableKey) in pageShowData.jurTableVo.jurconfigtable" :key="tableKey" show-overflow-tooltip :min-width="tableValye.fieldWeight"
          :prop="tableValye.entityField" :label="tableValye.showField">
          <template slot-scope="scope">
            <!-- <span v-if="tableValye.fieldType == 'date'">
              <span v-if="scope.row[tableValye.entityField]">
                {{ $common.getLocalTime(scope.row[tableValye.entityField]) }}
              </span>
            </span> -->
            <span v-if="tableValye.fieldType == 'date' && scope.row[tableValye.entityField]">
                            {{ $common.getLocalTime(scope.row[tableValye.entityField]) }}
                        </span>
                        <span v-else-if="tableValye.fieldType == 'dateTime' && scope.row[tableValye.entityField]">
                            {{ $common.getLocalTime(scope.row[tableValye.entityField], true) }}
                        </span>
            <span v-else-if="tableValye.fieldType == 'formatter'">
              <span v-for="(item, index) in JSON.parse(tableValye.formatterContent)" :key="index">
                <el-tag size="mini" v-if="item.key == scope.row[tableValye.entityField]">{{
                                    item.value }}</el-tag>
              </span>
            </span>
            <span v-else-if="tableValye.isRift == 1">
              <a @click="toDetail(scope.row[tableValye.riftField])">{{
                                scope.row[tableValye.entityField] }}</a>
            </span>
            <span v-else>
              {{ scope.row[tableValye.entityField] }}
            </span>
          </template>
        </el-table-column>
      </el-table>
    </div>
    <div class="page_content_bottom">
      <v-pagination :page="getRequestData.page" :rows="getRequestData.rows" :total="returnData.total" @setDataPageSize="setDataPageSize" @setDataPageNumber="setDataPageNumber"></v-pagination>
    </div>
    <el-dialog :title="seTitle" v-if="DialogVisible" :visible.sync="DialogVisible" :width="seWidth">
      <SearchScheme ref="searchScheme" :id="seId" :parentSearchData="parentSearchData" @TranData="changeInputModel" @getWidth="getSeWidth" @sendTitle="getSearchName" />
    </el-dialog>
    <!-- 自定义设计 -->
    <customDesign ref="customDesign"></customDesign>
  </div>
</template>

<script>
//这里可以导入其他文件（比如：组件，工具js，第三方插件js，json文件，图片文件等等）
//例如：import 《组件名称》 from '《组件路径》';
import SearchScheme from "../../../byComponents/SearchScheme.vue";
export default {
  //import引入的组件需要注入到对象中才能使用
  components: {
    SearchScheme,
  },
  data() {
    //这里存放数据
    return {
      tableHeight: 0,
      getRequestData: {
        rgamRapcus: "",
        rgamPurchaser: "",
        rgamRapcusName: "",
        page: 1,
        rows: 30,
        start:
          new Date(new Date().toLocaleDateString()).getTime() -
          31 * 24 * 3600 * 1000,
        end:
          new Date(new Date().toLocaleDateString()).getTime() +
          24 * 60 * 60 * 1000 -
          1,
        smId: "",
        smName: "",
      },
      returnData: {
        pages: 0, // 总页数
        total: 0, // 总条数
        pageNum: 0, // 当前页数
        list: [],
      },
      buttonList: [],
      userOneList: [],
      pageShowData: [],
      selectedDataIndex: 0,
      exId: "",
      seId: "",
      ceshi: "",
      dialogTitle: "",
      seWidth: "",
      height: "",
      exTitle: "",
      seTitle: "",
      seWidth: "",
      exWidth: "",
      DialogVisible: false,
      DialogExtract: false,
      newFormDataList: [],
      seType: "",
      smId: "",
      parentSearchData: {},
      sField: "",
      selectVal: []
    };
  },
  //监听属性 类似于data概念
  computed: {},
  //监控data中的数据变化
  watch: {
    "getRequestData.rgamRapcusName": {
      handler: function (newValue, oldValue) {
        if (newValue == "") {
          this.getRequestData.rgamRapcus = "";
        }
      },
      deep: true,
    },
  },
  //方法集合
  methods: {
    handleSelectionChange(val) {
      this.selectVal = val
    },
    // 点击穿透字段 传参单号
    toDetail(orderId) {
      if (orderId) {
        // 设置为true 打开穿透组件首页
        var isPenetrate = true;
        // 设置缓存 存入点击单号
        this.resetSetItem("penetrateOrderId", orderId);
        // 与父级跨域通信 传递isPenetrate参数
        window.parent.postMessage(
          {
            //向窗口发送MessageEvent消息
            cmd: "returnFormJson",
            params: { isPenetrate }, //参数
          },
          "*"
        );
      }
    },
    //检索带回数据
    changeInputModel(val) {
      if (val != "" || val != undefined) {
        this.DialogVisible = false;
        this.paramValue(val);
      }
    },
    // 赋值字段
    paramValue(val) {
      let arr = this.sField.split(",");
      arr.forEach((item) => {
        this.getRequestData[item] = val[item];
      });
    },
    getSeWidth(e) {
      console.log(e);
      this.seWidth = e + "%";
    },
    getWidth(e) {
      console.log(e);
      this.exWidth = e + "%";
    },
    getSearchName(e) {
      console.log(e);
      this.seTitle = e;
    },
    getExtractName(e) {
      console.log(e);
      this.exTitle = e;
    },
    // 检索Id, 索引(表格中), 标识
    openSearch({ sId, index, type, sField }) {
      this.DialogVisible = true;
      this.seId = sId;
      this.sField = sField;
      this.parentSearchData[type] = this.getRequestData[type];
    },
    isShowData(name, value) {
      console.log(name);
      switch (name) {
        case "rgamRapcus":
          var dataInfo = sessionStorage.getItem("selectSupplierData");
          if (dataInfo) {
            dataInfo = JSON.parse(dataInfo);
            this.getRequestData.rgamRapcus = dataInfo.smId;
            this.getRequestData.rgamRapcusName = dataInfo.smName;
          }
          break;
        default:
          this.getRequestData[name] = value;
      }
    },

    // 获取数据列表
    async getPageInfo() {
      var pathId = parent.getMenuInfo(this.$route.path);
      let responseData = await this.$http.getJur({ ids: [pathId.jurId] });
      if (responseData.status == 200) {
        this.pageShowData = responseData.result;
        var obj = {}
        if (this.pageShowData.jurHead) {
          obj = this.$common.getSearchData(this.pageShowData.jurHead.jurconfigform, 'page', "rows", 30, false)
        } else {
          obj = this.$common.getSearch(this.getRequestData, 'start', 'end', 'page', 'rows', 30, false)
        }
        for (const key in obj) {
          this.$set(this.getRequestData, key, obj[key])
        }
        this.getDataList();
      } else {
        this.$message({
          message: responseData.message,
          type: "error",
        });
      }
    },
    // 动作集合
    actionSet(actionData) {
      if (actionData.actionType != 15) {
        if (this.returnData.list.length <= 0) {
          this.$message({
              message: "暂无数据",
              type: "error",
            });
            return false;
        }
        if (this.selectVal.length == 0) {
          this.$message({
            message: "请先选择您要操作的数据",
            type: "error",
          });
          return false;
        }
      }

      switch (actionData.actionType) {
        case 4:
          var arr = []
          this.selectVal.forEach(item => {
            arr.push(item.rganomId)
          })
          this.$refs["processAuditAction"].openBox(0, arr);
          break;
        case 5:
          if (this.selectVal.length > 1) {
            this.$message({
              message: "请勾选一条数据",
              type: "error",
            });
            return false;
          }
          this.$refs["processAuditAction"].openBox(1, this.selectVal[0].rganomId);
          break;
      }
    },
    openFormDesign() {
      let pathInfo = parent.getMenuInfo(this.$route.path)
      this.$refs['customDesign'].openBox(pathInfo.jurId, this.pageShowData, pathInfo.jurName)
    },
    // 获取供货员
    async getSpecialUser() {
      let responseData = await this.$http.getSpecialUser({ opmBuyer: 1 });
      if (responseData.status == 200) {
        this.userOneList = responseData.result;
      } else {
        this.$message({
          message: responseData.message,
          type: "error",
        });
      }
    },
    // 数据搜索
    searchData() {
      this.getRequestData.page = 1;
      this.getDataList();
    },
    // 数据翻页
    setDataPageNumber(val) {
      this.getRequestData.page = val;
      this.getDataList();
    },
    // 切换显示条数
    setDataPageSize(val) {
      this.getRequestData.page = 1;
      this.getRequestData.rows = val;
      this.getDataList();
    },
    // 获取数据列表
    async getDataList() {
      if (this.getRequestData.smName == "") {
        this.getRequestData.smId = "";
      }
      let responseData = await this.$http.queryTaskRgApplynotices(
        this.getRequestData
      );
      if (responseData.status == 200) {
        this.returnData.list = responseData.result.list;
        this.returnData.pages = responseData.result.pages;
        this.returnData.total = responseData.result.total;
        this.returnData.pageNum = responseData.result.pageNum;
        this.selectedDataIndex = 0;
      } else {
        this.$message({
          message: responseData.message,
          type: "error",
        });
      }
    },

    // 获取按钮权限
    async getButtonList() {
      this.buttonList = await this.$common.getActionButton()
      
    },
},
  //生命周期 - 创建完成（可以访问当前this实例）
  created() {
    this.getPageInfo();
    this.getDataList();
    this.getButtonList();
    this.getSpecialUser();
  },
  //生命周期 - 挂载完成（可以访问DOM元素）
  mounted() { },
  beforeCreate() { }, //生命周期 - 创建之前
  beforeMount() { }, //生命周期 - 挂载之前
  beforeUpdate() { }, //生命周期 - 更新之前
  updated() { this.tableHeight = this.$common.getTableHeight() }, //生命周期 - 更新之后
  beforeDestroy() { }, //生命周期 - 销毁之前
  destroyed() { }, //生命周期 - 销毁完成
  activated() { }, //如果页面有keep-alive缓存功能，这个函数会触发
};
</script>
<style scoped>
.table_content_tag {
  margin-right: 1rem;
}

.el-tabs--border-card_new {
  height: 85vh;
  overflow-y: scroll;
}
</style>